import { RECEIVING_ITEM_ERROR_DATA } from '../actions/actionType'

const initialState = {
  receivingItemErrorList: [],
}
export default function ReceivingItemErrorsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVING_ITEM_ERROR_DATA:
      return { ...state, receivingItemErrorList: action.payload }
    default:
      return state
  }
}
